import { useState } from "react";
import { Sparkles, ChevronDown } from "lucide-react";

import { AISummaryExpanded } from "./ai-summary-expanded";
import { getApiConfigSafe } from "../../utils/api-config";

import "./ai-summary.scss";

export interface AISummaryPanelProps {
  aiSummaryData?: any;
  isLoading?: boolean;
  isError?: boolean;
  onExpand?: () => void;
}

export function AISummaryPanel(props: AISummaryPanelProps = {}) {
  const isAiEnabled = getApiConfigSafe()?.aiFeatureEnabled === 'true';
  if (!isAiEnabled) return null;

  const { aiSummaryData, isLoading, isError, onExpand } = props;
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="ai-summary-panel">
      {!expanded && (
        <button
          onClick={() => {
            setExpanded(true);
            onExpand?.();
          }}
          className="ai-summary-panel__collapsed-toggle"
          disabled={isLoading}
        >
          <div className="ai-summary-panel__collapsed-toggle-icon">
            {isLoading ? (
              <div className="ai-summary-panel__loading-spinner" />
            ) : (
              <Sparkles />
            )}
          </div>

          <span className="ai-summary-panel__collapsed-toggle-title">AI Summary</span>

          <span className="ai-summary-panel__collapsed-toggle-subtitle">
            {isLoading ? "Generating insights..." : "Click to expand insights"}
          </span>

          {!isLoading && (
            <ChevronDown className="ai-summary-panel__collapsed-toggle-chevron" />
          )}
        </button>
      )}

      {expanded && (
        <AISummaryExpanded
          aiSummaryData={aiSummaryData}
          isLoading={isLoading}
          isError={isError}
          onCollapse={() => setExpanded(false)}
        />
      )}
    </div>
  );
}

export default AISummaryPanel;
